var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticStyle: { "margin-top": "1vh" },
          attrs: {
            visible: _vm.dialogVisible,
            "modal-append-to-body": false,
            width: "810px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "title", attrs: { slot: "title" }, slot: "title" },
            [_vm._v("客户添加")]
          ),
          _c(
            "div",
            { staticClass: "table-container" },
            [
              _c(
                "div",
                { staticClass: "btn-wrap" },
                [
                  _c(
                    "el-tag",
                    {
                      staticClass: "select-stafft-wrap",
                      attrs: {
                        title: "选择员工",
                        closable:
                          _vm.searchMenNames.length === 0 ? false : true,
                        type: "medium",
                        effect: "plain"
                      },
                      on: {
                        close: _vm.searchCloseTag,
                        click: function($event) {
                          return _vm.clickAddMember()
                        }
                      }
                    },
                    [
                      _vm.searchMenNames.length === 0
                        ? _c("span", [_vm._v("选择员工")])
                        : _vm._e(),
                      _vm._l(_vm.searchMenNames, function(item, index) {
                        return _c(
                          "span",
                          { key: index, staticClass: "staff-names" },
                          [
                            _vm._v(_vm._s(item.name)),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.searchMenNames.length > 1 &&
                                      index != _vm.searchMenNames.length - 1,
                                    expression:
                                      "\n                searchMenNames.length > 1 &&\n                  index != searchMenNames.length - 1\n              "
                                  }
                                ]
                              },
                              [_vm._v(",")]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _c("el-date-picker", {
                    staticStyle: { width: "240px" },
                    attrs: {
                      size: "mini",
                      editable: false,
                      type: "daterange",
                      "value-format": "yyyy-MM-dd",
                      "range-separator": "-",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      "picker-options": _vm.pickerOptions,
                      clearable: ""
                    },
                    on: { change: _vm.selectTime },
                    model: {
                      value: _vm.searchSelectTime,
                      callback: function($$v) {
                        _vm.searchSelectTime = $$v
                      },
                      expression: "searchSelectTime"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "table-data" },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading"
                        }
                      ],
                      ref: "singleTable",
                      staticStyle: {
                        width: "100%",
                        height: "100%",
                        "font-size": "13px"
                      },
                      attrs: {
                        size: "medium",
                        "header-cell-style": {
                          background: "#eef1f6",
                          color: "#606266"
                        },
                        "highlight-current-row": true,
                        data: _vm.staffData,
                        height: "308px"
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "rowNumb",
                          label: "客户",
                          width: "200",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("div", { staticClass: "customer" }, [
                                  _c(
                                    "div",
                                    { staticClass: "customer-avatar" },
                                    [
                                      _c("el-avatar", {
                                        attrs: {
                                          size: "medium",
                                          shape: "square",
                                          src: scope.row.avatar
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "name-wrap" }, [
                                    scope.row.ctmName != null
                                      ? _c(
                                          "div",
                                          { staticClass: "document-name" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(scope.row.ctmName) +
                                                " "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          { staticClass: "document-name" },
                                          [_vm._v("--")]
                                        ),
                                    _c(
                                      "div",
                                      { staticClass: "nickname-wrap" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "nickname",
                                            style:
                                              scope.row.type == 1
                                                ? ""
                                                : "max-width:5em;"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(scope.row.externalName) +
                                                " "
                                            )
                                          ]
                                        ),
                                        scope.row.type == 1
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "rgb(70, 189, 10)"
                                                }
                                              },
                                              [_vm._v(" @微信")]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "rgb(8, 168, 231)"
                                                }
                                              },
                                              [_vm._v(" @企业微信")]
                                            )
                                      ]
                                    )
                                  ])
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "name",
                          label: "客户标签",
                          "min-width": "140",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          "popper-class": "my-popper",
                                          placement: "top-start",
                                          trigger: "hover"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "hover-wrap" },
                                          _vm._l(scope.row.tag, function(
                                            item,
                                            index
                                          ) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass: "wrap-li"
                                              },
                                              [_vm._v(" " + _vm._s(item) + " ")]
                                            )
                                          }),
                                          0
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "tag-list",
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          _vm._l(scope.row.tag, function(
                                            item,
                                            index
                                          ) {
                                            return _c(
                                              "el-tag",
                                              {
                                                key: index,
                                                staticStyle: {
                                                  margin: "5px 4px 0 0"
                                                },
                                                attrs: { size: "small" }
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(_vm._s(item))
                                                ])
                                              ]
                                            )
                                          }),
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "addWayMean",
                          label: "添加来源",
                          "min-width": "120",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "createTime",
                          label: "添加时间",
                          "min-width": "160",
                          align: "center"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "userName",
                          "show-overflow-tooltip": "",
                          label: "添加员工",
                          "min-width": "118",
                          align: "center"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("el-pagination", {
                attrs: {
                  background: true,
                  "current-page": _vm.pageparm.currentPage,
                  "page-size": _vm.pageparm.pageSize,
                  layout: "prev, pager, next, jumper",
                  total: _vm.pageparm.total
                },
                on: {
                  "current-change": _vm.callBack,
                  "update:currentPage": function($event) {
                    return _vm.$set(_vm.pageparm, "currentPage", $event)
                  },
                  "update:current-page": function($event) {
                    return _vm.$set(_vm.pageparm, "currentPage", $event)
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ]
      ),
      _c("StaffTree", {
        attrs: {
          title: "选择成员",
          dialogVisibleTree: _vm.dialogVisibleTree,
          currentSelectMember: _vm.currentSelectMember
        },
        on: { closeTree: _vm.closeTree, clickSubmitTree: _vm.clickSubmitTree }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }